'use strict';exports.__esModule = true;exports.clearStoreNotes = exports.addSavedNotesToStore = exports.addPropertyNote = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _unionWith = require('lodash/unionWith');var _unionWith2 = _interopRequireDefault(_unionWith);
var _differenceWith = require('lodash/differenceWith');var _differenceWith2 = _interopRequireDefault(_differenceWith);
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var addPropertyNote = (0, _reduxAct.createAction)('/ADD_PROPERTY_NOTE');
var addSavedNotesToStore = (0, _reduxAct.createAction)('/ADD_SAVED_NOTES_TO_STORE');
var connectPropertyNoteToUserSuccess = (0, _reduxAct.createAction)('/CONNECT_PROPERTY_NOTE_TO_USER_SUCCESS');
var connectPropertyNoteToUserFail = (0, _reduxAct.createAction)('/CONNECT_PROPERTY_NOTE_TO_USER_FAIL');
var clearStoreNotes = (0, _reduxAct.createAction)('/CLEAR_STORE_NOTES');

var initialState = {
  data: [],
  loading: false,
  loaded: false };


var comparator = function comparator(value, other) {return value.id === other.id;};

var syncNotes = function syncNotes() {var userNotes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var savedNotes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var union = (0, _unionWith2.default)(savedNotes, userNotes, comparator);
  var difference = (0, _differenceWith2.default)(union, userNotes, comparator);

  return {
    union: union,
    difference: difference };

};

var convertNotesObjectToArray = function convertNotesObjectToArray() {var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var responseKeys = Object.keys(response);

  return responseKeys.reduce(function (acc, id) {
    acc.push({ id: id, note: response[id] });
    return acc;
  }, []);
};

var connectNoteToUserHandler = function connectNoteToUserHandler(_ref) {var noteData = _ref.noteData,noteShouldBeDeleted = _ref.noteShouldBeDeleted,token = _ref.token;
  var requestType = noteShouldBeDeleted ? 'patch' : 'post';
  var data = noteShouldBeDeleted ? { id: noteData.id } : noteData;

  return (0, _axios2.default)({
    method: requestType,
    url: '/users/properties/notes',
    headers: {
      access_token: token },

    data: data }).

  then(connectPropertyNoteToUserSuccess, connectPropertyNoteToUserFail);
};

var addNotesArrayToUserHandler = function addNotesArrayToUserHandler(_ref2) {var notesData = _ref2.notesData,token = _ref2.token;return (
    _axios2.default.post('/users/properties/notes', { notes: notesData }, { headers: { access_token: token } }).
    then(connectPropertyNoteToUserSuccess, connectPropertyNoteToUserFail));};

var connectNoteToUserSuccessHandler = function connectNoteToUserSuccessHandler(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: convertNotesObjectToArray(action.data) });};


var connectNoteToUserFailHandler = function connectNoteToUserFailHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while connecting note to user');
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var connectPropertyNoteToUser = function connectPropertyNoteToUser(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false }),
  promise(connectNoteToUserHandler, action));};

var addNotesArrayToUser = function addNotesArrayToUser(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    loaded: false }),
  promise(addNotesArrayToUserHandler, action));};

var addPropertyNoteHandler = function addPropertyNoteHandler(state, _ref3) {var noteData = _ref3.noteData,token = _ref3.token;
  var data = [].concat(state.data);
  var existingNote = data.find(function (item) {return item.id === noteData.id;});
  var noteIdx = data.indexOf(existingNote);
  var noteShouldBeDeleted = existingNote && !noteData.note;

  if (noteShouldBeDeleted) {
    data.splice(noteIdx, 1);
  } else if (existingNote) {
    data[noteIdx].note = noteData.note;
  } else if (noteData.note) {
    data.push(noteData);
  }

  return token ?
  connectPropertyNoteToUser(Object.assign({}, state, { data: data }), { noteData: noteData, noteShouldBeDeleted: noteShouldBeDeleted, token: token }) :
  function () {
    _constants.storage.value.setItem('propertyNotes', JSON.stringify(data));

    return Object.assign({},
    state, {
      data: data });

  }();
};

var addSavedNotesToStoreHandler = function addSavedNotesToStoreHandler(state, _ref4) {var notesData = _ref4.notesData,token = _ref4.token;
  var savedNotes = _constants.storage.value.getItem('propertyNotes');
  var userNotesData = convertNotesObjectToArray(notesData);
  var savedNotesData = [];

  if (savedNotes) {
    try {
      savedNotesData = JSON.parse(savedNotes);
    } catch (err) {
      console.error(err.message);
    }
  }var _syncNotes =

  syncNotes(userNotesData, savedNotesData),union = _syncNotes.union,difference = _syncNotes.difference;

  return token && difference.length ?
  addNotesArrayToUser(state, { notesData: difference, token: token }) : Object.assign({},

  state, {
    data: union });

};

var clearStoreNotesHandler = function clearStoreNotesHandler(state) {return Object.assign({},
  state, {
    data: [] });};


var propertyNotes = (0, _reduxAct.createReducer)(function (on) {
  on(addPropertyNote, addPropertyNoteHandler);
  on(addSavedNotesToStore, addSavedNotesToStoreHandler);
  on(connectPropertyNoteToUserSuccess, connectNoteToUserSuccessHandler);
  on(connectPropertyNoteToUserFail, connectNoteToUserFailHandler);
  on(clearStoreNotes, clearStoreNotesHandler);
}, initialState);exports.


addPropertyNote = addPropertyNote;exports.
addSavedNotesToStore = addSavedNotesToStore;exports.
clearStoreNotes = clearStoreNotes;exports.default =


propertyNotes;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertyNotes.js
// module id = 199
// module chunks = 0